import wrapError from "@/components/helpers/wrapError"

export const apiDownloadEmailData = (success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/exportSubscriptionsManager",
    success,
    error: wrapError(error, "apiDownloadEmailData"),
  })
}

export const apiAdminFetchConstituentSubscriptions = (userId, success, error) => {
  $.ajax({
    type: "GET",
    url: `/api/admin/adminSubscriptionManager/${userId}`,
    success,
    error: wrapError(error, "apiAdminFetchConstituentSubscriptions"),
  })
}
